import studentService from "../../services/student.service";
import TeacherService from "../../services/teacher.service";
import ParentService from "../../services/parent.service";
import SituationsService from "../../services/situations.service";
import ActivitiesService from "../../services/activities.service";
import ServicesService from "../../services/services.service";

export default {
  state: {
    filters: {},
    student: {
      first_name: "",
      last_name: "",
      phone_number: null,
      email: null,
      birthday: "",
      place_of_birth: "",
      photo: "",
      class_school_id: null,
      class_type_id: null,
      student_situation_id: "",
      parent_situation_ids: [],
      student_gender: null,
      additional_information: "",
      otherparent: null,
      id: "",
      parents: [
        {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          function: null,
          gender: null,
          lieu_travail: null,
          relation_eleve: null,
          ville: null,
          pays: null,
          code_postale: null,
          addresse: null,
        },
        {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          function: null,
          gender: null,
          lieu_travail: null,
          relation_eleve: null,
          ville: null,
          pays: null,
          code_postale: null,
          addresse: null,
        },
      ],
      parents_tuteur: [
        {
          first_name: "",
          last_name: "",
          email: "",
          relation_eleve: "",
          addresse: "",
          ville: "",
          code_postale: "",
          pays: "",
        },
      ],
      scolarities: [
        {
          school_year: "",
          school_name: "",
          class_type_id: null,
          class_school_id: null,
        },
      ],
      activities: [
        {
          activity_id: null,
          description: "",
        },
      ],
      services: [
        {
          service_id: null,
          discount_type: "1",
          discount_value: 0,
          error: false,
          errorPercent: false,
          errorNumber: false,
          maxAmount: null,
        },
      ],
    },
    situationParent: [],
    situationStudent: [],
    activities: [],
    services: [],
  },
  getters: {
    getScolarityFilter: (state) => state.filters,
    getStudent: (state) => state.student,
    getParentSituations: (state) => state.situationParent,
    getStudentsSituations: (state) => state.situationStudent,
    getActivity: (state) => state.activities,
    getServices: (state) => state.services,
  },
  mutations: {
    SET_FILTER_SCOLARITE(state, payload) {
      state.filters = payload;
      state.student.scolarities.map((item) => {
        item.school_name = payload?.school_name;
      });
    },
    UPDATE_VALUE_STUDENT(state, payload) {
      state.student[payload.key] = payload.value;
    },
    UPDATE_VALUE_STUDENT_ARRAY(state, payload) {
      state.student[payload.params][payload.index][payload.key] = payload.value;
    },
    PUSHED_ARRAY_STUDENT(state, payload) {
      state.student[payload.key].push(payload.value);
    },
    REMOVE_ARRAY_STUDENT(state, payload) {
      state.student[payload.key] = state.student[payload.key].filter((el, index) => index != payload.index);
    },
    SET_STUDENT_SITUATION(state, payload) {
      state.situationStudent = payload;
    },
    SET_PARENT_SITUATION(state, payload) {
      state.situationParent = payload;
    },
    SET_ACTIVITIES(state, payload) {
      state.activities = payload;
    },
    SET_SERVICES(state, payload) {
      state.services = payload.filter((item) => item.is_active == 1);
    },
  },
  actions: {
    async getFilterStudentsScolarity({commit}, payload) {
      try {
        const response = await studentService.getFilterScolarity(payload);
        commit("SET_FILTER_SCOLARITE", response.data);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
    async blocageStudent({commit}, payload) {
      try {
        const response = await studentService.enableStudent(payload.id, payload.payload);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
    async blocageTeacher({commit}, payload) {
      try {
        const response = await TeacherService.enableTeacher(payload.id, payload.payload);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
    async blocageParent({commit}, payload) {
      try {
        const response = await ParentService.enableParent(payload.id, payload.payload);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
    async getListStudentSituation({commit}) {
      try {
        const response = await SituationsService.getStudentSituation();
        commit("SET_STUDENT_SITUATION", response.data.data);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
    async getListParentSituation({commit}) {
      try {
        const response = await SituationsService.getParentSituation();
        commit("SET_PARENT_SITUATION", response.data.data);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
    async getListActivities({commit}) {
      try {
        const response = await ActivitiesService.getAll();
        commit("SET_ACTIVITIES", response.data.data);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
    async getListServices({commit}) {
      try {
        const response = await ServicesService.getAllActive();
        commit("SET_SERVICES", response.data.data);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
    async blocageAdmin({commit}, payload) {
      try {
        const response = await TeacherService.enableAdmin(payload.id, payload.payload);
        return true;
      } catch (error) {
        console.error("error : ", error);
        return false;
      }
    },
  },
};
